module.exports = __webpack_public_path__ + "img/print-example-table-tent.dbf8a1e3.png";